const handler = ( $ ) => {
	const $window = $( window ),
		responsiveBreakpoint = 1199.98,
		$headerSpacer = $( '#header-spacer' ),
		$header = $( '#header' ),
		$topBar = $( '.top-bar' ),
		$wpAdminBar = $( '#wpadminbar' );

	let headerInitPos, adminBarHeight, topBarHeight;

	const initHeader = function () {
		headerInitPos = $header.offset().top;
		topBarHeight = $topBar.outerHeight();
		adminBarHeight = $wpAdminBar.is( ':visible' )
			? $wpAdminBar.outerHeight()
			: 0;
		$headerSpacer.css( 'paddingBottom', $header.outerHeight() + 'px' );
	};

	initHeader();

	const initHeaderScroll = function () {
		let scrollTop = $window.scrollTop();

		if ( scrollTop >= headerInitPos - adminBarHeight ) {
			$header
				.css( 'position', 'fixed' )
				.css( 'top', adminBarHeight + 'px' );

			$( 'body' ).addClass( 'sign-in' );
		} else {
			$header
				.css( 'position', 'absolute' )
				.css( 'top', topBarHeight + adminBarHeight + 'px' );

			$( 'body' ).removeClass( 'sign-in' );
		}
	};

	initHeaderScroll();

	$window.on( 'scroll', initHeaderScroll );

	$( '#header .search-toggle a' ).on( 'click', function ( e ) {
		e.preventDefault();

		$( this ).parents( 'li' ).toggleClass( 'is-open' );

		let $search;

		if ( $window.width() >= responsiveBreakpoint ) {
			$search = $( '#header .head-search' );
		} else {
			$search = $( '#header .head-search-mobile' );
		}

		$search.slideToggle( function () {
			if ( $( this ).is( ':visible' ) ) {
				$( this ).find( 'input[type=text]' ).focus();
			}
		} );
	} );

	$( '#header .head-search input[type=text]' ).on( 'input', function () {
		const $clear = $( '#header .head-search-clear' );
		if ( $( this ).val().length > 0 ) {
			$clear.addClass( 'is-visible' );
		} else {
			$clear.removeClass( 'is-visible' );
		}
	} );

	$( '#header .head-search-clear' ).on( 'click', function () {
		const $input = $( '#header .head-search input[type=text]' );
		$input.val( '' ).focus();
		$( this ).removeClass( 'is-visible' );
	} );

	const accountToggleSelector = '#header-account-menu-toggle';
	const submenuToggleSelector = '#header .header-submenu-toggle';
	const headerMenuToggleSelector = `${ accountToggleSelector }, ${ submenuToggleSelector }`;

	const getToggleMenu = function ( $toggle ) {
		if ( $toggle.is( accountToggleSelector ) ) {
			return $( '#header-account-menu' );
		}

		return $toggle
			.closest( '.menu-item-has-children' )
			.children( '.sub-menu' );
	};

	const setToggleState = function ( $toggle, isOpen ) {
		$toggle
			.toggleClass( 'is-open', isOpen )
			.attr( 'aria-expanded', isOpen ? 'true' : 'false' );
		$toggle
			.closest( '.menu-item-has-children' )
			.toggleClass( 'is-open', isOpen );
	};

	const closeToggleMenu = function ( $toggle, speed = 'fast' ) {
		const $menu = getToggleMenu( $toggle );

		if ( ! $menu.length ) {
			return;
		}

		$( 'body' ).removeClass( 'menu-is-open' );
		setToggleState( $toggle, false );
		$menu.stop( true, true ).slideUp( speed );
	};

	const closeAllHeaderMenus = function ( $exceptToggle = null, speed = 'fast' ) {
		const exceptElement =
			$exceptToggle && $exceptToggle.length ? $exceptToggle.get( 0 ) : null;

		$( headerMenuToggleSelector ).each( function () {
			if ( exceptElement && this === exceptElement ) {
				return;
			}

			closeToggleMenu( $( this ), speed );
		} );
	};

	$( '.mobile-menu-toggle' ).on( 'click', function ( e ) {
		e.preventDefault();
		$( this ).toggleClass( 'is-open' );
		$( '#header .menu-holder' ).slideToggle( 'fast' );
		closeAllHeaderMenus( null, 'fast' );
	} );

	// Make .link-wrapper clickable on mobile
	$( document ).on( 'click', '.menu-item-has-children > .link-wrapper', function ( e ) {
		if ( $window.width() < responsiveBreakpoint && ! $( e.target ).closest( 'a' ).length ) {
			e.preventDefault();
			e.stopImmediatePropagation();

			const $toggle = $( this ).children( '.header-submenu-toggle' ).first();
			const $menu = getToggleMenu( $toggle );
			if ( ! $menu.length ) {
				return;
			}

			const isOpen = $toggle.hasClass( 'is-open' );
			closeAllHeaderMenus( $toggle, 'fast' );

			if ( isOpen ) {
				closeToggleMenu( $toggle, 'fast' );
				return;
			}

			setToggleState( $toggle, true );
			$menu.stop( true, true ).slideDown( 'fast', function () {
				$( 'body' ).addClass( 'menu-is-open' );
			} );
		}
	} );

	$( document ).on( 'click', headerMenuToggleSelector, function ( e ) {
		const $toggle = $( this );
		const $menu = getToggleMenu( $toggle );

		if ( ! $menu.length ) {
			return;
		}

		e.preventDefault();

		const isOpen = $toggle.hasClass( 'is-open' );

		closeAllHeaderMenus( $toggle, 'fast' );

		if ( isOpen ) {
			closeToggleMenu( $toggle, 'fast' );
			return;
		}

		setToggleState( $toggle, true );
		$menu.stop( true, true ).slideDown( 'fast', function () {
			$( 'body' ).addClass( 'menu-is-open' );
		} );
	} );

	$( document ).on( 'click', '.mobile-link-back a', function ( e ) {
		e.preventDefault();

		let $toggle;

		if ( $( this ).closest( '#header-account-menu' ).length ) {
			$toggle = $( accountToggleSelector );
		} else {
			$toggle = $( this )
				.closest( '.menu-item-has-children' )
				.find( '.header-submenu-toggle' );
		}

		if ( $toggle.length ) {
			closeToggleMenu( $toggle, 'fast' );
		}
	} );

	// close toggles by clicking outside
	$( document ).on( 'click', function ( e ) {
		if ( $window.width() >= responsiveBreakpoint ) {
			if (
				$( e.target ).closest(
					`${ headerMenuToggleSelector }, #header .menu .menu-item-has-children > .sub-menu, .head-search, #header .search-toggle a`
				).length === 0
			) {
				closeAllHeaderMenus();
				$( '#header .head-search' ).slideUp();
				$( '.search-toggle' ).removeClass( 'is-open' );
			}
		} else {
			if ( $( e.target ).closest( '#header' ).length === 0 ) {
				$( '.mobile-menu-toggle' ).removeClass( 'is-open' );
				$( '#header .menu-holder' ).slideUp( 'fast' );
				$( '#header .head-search-mobile' ).slideUp();
				closeAllHeaderMenus();
			}
		}
	} );

	$window.on( 'resize', function () {
		initHeader();
		initHeaderScroll();

		if ( $window.width() >= responsiveBreakpoint ) {
			$( '#header .menu-holder' ).show();
		} else {
			$( '#header .menu-holder' ).hide();
		}

		$( '.mobile-menu-toggle' ).removeClass( 'is-open' );
		closeAllHeaderMenus();
		$( '#header .head-search-mobile, #header .head-search' ).hide();
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
